import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=4a10b724&"
import script from "./ModalComment.vue?vue&type=script&lang=js&"
export * from "./ModalComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a10b724')) {
      api.createRecord('4a10b724', component.options)
    } else {
      api.reload('4a10b724', component.options)
    }
    module.hot.accept("./ModalComment.vue?vue&type=template&id=4a10b724&", function () {
      api.rerender('4a10b724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalComment.vue"
export default component.exports